module.exports = __webpack_public_path__ + "static/media/buzak.c6ba734b.jpg";